import React, { useState } from 'react';
import './FAQSection.css';
import { FaBold } from 'react-icons/fa';

const FAQS = [
  {
    q: 'Do you offer customization on corporate gifts?',
    a: 'Yes, we provide logo branding and personalized gifting solutions for businesses.',
  },
  {
    q: 'Do you offer pan-India shipping?',
    a: 'Yes, we deliver corporate gifts across India with reliable logistics partners.',
  },
  {
    q: 'Can I place bulk orders for corporate gifting?',
    a: 'Yes, we specialize in bulk corporate gifting with custom branding options. Simply click the “For Enterprise” button in the header to fill out the form and connect with our team.',
  },
  {
    q: 'What payment methods are accepted on Corgif?',
    a: 'We support UPI, credit/debit cards, net banking, and secure payment gateways for smooth corporate transactions.',
  },
];

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="faq-section">
      <div className="faq-inner">

        <div className="faq-left">
          <h2 className="faq-heading">Any questions?<br />We got you.</h2>
          <p className="faq-desc">
            Yet bed any for assistance indulgence unpleasing. Not thoughts all exercise blessing.
            Indulgence way everything joy alteration boisterous the attachment.
          </p>
        </div>

        <div className="faq-right">
          {FAQS.map((item, i) => (
            <div key={i} className={`faq-item${openIndex === i ? ' open' : ''}`}>
              <button className="faq-question" onClick={() => toggle(i)}>
                <span className="faq-q-text">{item.q}</span>
                <span className="faq-icon">{openIndex === i ? '−' : '+'}</span>
              </button>
              <div className="faq-answer-wrap">
                <div className="faq-answer-inner">
                  <p className="faq-answer">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default FAQSection;
